"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAbsoluteURL = exports.preventDefaults = exports.noop = void 0;

var noop = function noop() {
  return null;
};

exports.noop = noop;

var preventDefaults = function preventDefaults() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  return function (ev) {
    ev.stopPropagation();
    ev.preventDefault();
    fn(ev);
  };
};

exports.preventDefaults = preventDefaults;

var isAbsoluteURL = function isAbsoluteURL(link) {
  var SCHEME_PATTERN = /(?:[a-z]+:)?\/\//;
  return SCHEME_PATTERN.test(link);
};

exports.isAbsoluteURL = isAbsoluteURL;